'use strict'

var visit = require('unist-util-visit')

module.exports = removePosition

/* Remove `position`s from `tree`. */
function removePosition(node, force) {
  visit(node, force ? hard : soft)
  return node
}

function hard(node) {
  delete node.position
}

function soft(node) {
  node.position = undefined
}



//////////////////
// WEBPACK FOOTER
// ./~/unist-util-remove-position/index.js
// module id = 1043
// module chunks = 95715928098905 168707334958949